export default {
  id: 0,
  nome: '',
  login: '',
  tipo: 'Domtec',
  status: 'Ativo'
}
